<template>
  <router-link :to="{ name: 'shopProductCategoryOverview', params: { productCategoryId: plainId } }" class="h-full">
    <div
      data-testid="shop-category-card"
      class="flex h-24 w-full cursor-pointer items-center gap-x-2 rounded-lg border border-main bg-surface py-3 text-main hover:bg-state-hover-neutral"
    >
      <div><img data-testid="shop-category-card-image" class="h-20 w-20" :src="category.imageUrl ?? ''" alt="" /></div>
      <div>
        <h2 data-testid="shop-category-card-name" class="line-clamp-2 txt-headline-m">{{ props.category?.name }}</h2>

        <p class="txt-body-s-regular text-subtle">
          <template v-if="expiryDate">
            <span v-if="!expired">{{ $t('FestivalShop.categoryCard.orderBy') }}</span>
            <span v-else>{{ $t('FestivalShop.categoryCard.expiryDate') }}</span> {{ formattedOrderByDate ?? ' ' }}
          </template>
          <template v-else>
            <br />
          </template>
        </p>
      </div>
    </div>
  </router-link>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { FestivalShopProductCategoriesQuery } from '@/gql/myomr'
import { toPlainId } from '@/helpers/globalIdHelper'

type Category = FestivalShopProductCategoriesQuery['festivalShopProductCategories']['nodes'][number]

const props = defineProps<{
  category: Category
}>()

const { locale } = useI18n()

const plainId = computed(() => toPlainId(props.category?.id))

const expiryDate = computed(() => (props.category.expiresAt ? new Date(props.category.expiresAt) : null))
const expired = computed(() => (expiryDate.value ? expiryDate.value < new Date() : false))

const formattedOrderByDate = computed(() => {
  if (!props.category.expiresAt) return '-'
  const date = new Date(props.category.expiresAt)
  return new Intl.DateTimeFormat(locale.value, { day: 'numeric', month: 'long' }).format(date)
})
</script>
